import * as moment from "moment";

export class DateHelper {
  static areDatesDifferent(date1?: moment.Moment, date2?: moment.Moment): boolean {
    // Check if both dates are undefined
    if (!date1 && !date2) {
      return false; // Both are undefined, so they are considered "not different"
    }

    // If only one of the dates is undefined, they are different
    if (!date1 || !date2) {
      return true;
    }

    // Compare the two dates using moment's isSame method
    return !date1.isSame(date2);
  }

  static formatDate(date: moment.Moment | undefined, format: string): string {
    return date && date.format(format) !== "Invalid date" ? date.format(format) : '';
  };

  static getFormatMoment(date: string, format: string): moment.Moment | undefined {
    if (date == undefined || date == '') return undefined;
    return moment(date, format ?? "DD/MM/YYYY").utc(false);
  }

  static isGeaterThan(input: string, compareWith: string, format: string): boolean {
    if (!input || input == '' || !compareWith || compareWith == '') { return true };
    const compareWithDate = moment(compareWith, format, true);
    const inputDate = moment(input, format, true);

    return inputDate.isAfter(compareWithDate, 'day') ? true : false;
  }

  static isEqualOrGeaterThan(input: string, compareWith: string, format: string): boolean {
    if (!input || input == '' || !compareWith || compareWith == '') { return true };
    const compareWithDate = moment(compareWith, format, true);
    const inputDate = moment(input, format, true);

    return inputDate.isSameOrAfter(compareWithDate, 'day') ? true : false;
  }

  static isLowerThan(input: string, compareWith: string, format: string): boolean {
    if (!input || input == '' || !compareWith || compareWith == '') { return true };
    const compareWithDate = moment(compareWith, format, true);
    const inputDate = moment(input, format, true);

    return inputDate.isBefore(compareWithDate, 'day') ? true : false;
  }

  static isEqualOrLowerThan(input: string, compareWith: string, format: string): boolean {
    if (!input || input == '' || !compareWith || compareWith == '') { return true };
    const compareWithDate = moment(compareWith, format, true);
    const inputDate = moment(input, format, true);

    return inputDate.isSameOrBefore(compareWithDate, 'day') ? true : false;
  }
}
